import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";

// helpers
import { showMessage } from "../../helpers/message.js";
import { removeAllCookies } from "../../helpers/cookies.js";

// api
import usuario_api from "../../api/usuario_api.js";

export default function EsqueceuSenha({ history }) {

    const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    useEffect(() => {
        removeAllCookies();
    }, []);

    const handleVoltar = () => {
        history.push("/auth/login")
    }

    const onSubmit = (data) => {
        let json_submit = {
            login: data.login,
            email: data.email
        };

        setshowLoading(true);
        usuario_api.esqueceu_senha(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else if (result.data == null) {
                showMessage("Aviso", "Usuário não encontrado", 'warning', null);
            }
            else {
                showMessage("Aviso", "Uma senha temporária foi enviada para seu email!", 'success', function () {
                    history.push("/auth/login");
                });
            }
        });
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Card style={{ marginTop: "10vh" }}>
                <CardBody>
                    <Container>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="mt-4 pl-4">
                                <Col lg="6" md="12" className="text-center">
                                    <h5>Bem Vindo ao FLIC!</h5>
                                    <label className="text-center">Sistema de Fiscalização Integrada de Coleta da Prefeitura</label>
                                    <div className="mb-4">
                                        <img src={require("assets/img/logo.png")} className="mt-4" />
                                    </div>
                                </Col>
                                <Col lg="6" md="12" className="mb-4">
                                    <Row>
                                        <Col md="12">
                                            < Row>
                                                <Col md="12" lg="12">
                                                    <h5 className="text-center">Preencha para recuperar sua senha</h5>
                                                    <FormGroup>
                                                        <label>Login</label>
                                                        <Input
                                                            type="text"
                                                            name="login"
                                                            maxLength="200"
                                                            innerRef={register({ required: true })}
                                                        />
                                                        {errors.login && <span className="form-control-label text-danger" style={{display: 'block'}}>* Campo Obrigatório</span>}
                                                        <label className="mt-2">Email</label>
                                                        <Input
                                                            type="email"
                                                            name="email"
                                                            maxLength="200"
                                                            innerRef={register({ required: true })}
                                                        />
                                                        {errors.email && <span className="form-control-label text-danger" style={{display: 'block'}}>* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className="text-right">
                                        <Button color="link" className="btn-mobile" type="button" onClick={handleVoltar}>VOLTAR </Button>
                                        <Button color="success" className="btn-mobile" type="submit">ENVIAR EMAIL </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </CardBody>
            </Card>
        </>
    );
}